import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Translate, I18n } from 'react-redux-i18n';
import serialize from 'form-serialize';
import moment from 'moment';
import { Refresh } from 'components/Pagination';
import Smart from 'components/Smart';
import AuthView from 'components/AuthView';
import Form from 'components/Form';
import FlexGroup from 'components/FlexGroup';
import AuthFeature from 'components/AuthFeature';
import { AUTH_EDIT_TICKET } from 'constants/permission';
import { convertToUTC } from 'helpers/time-handler';
import NavigationBar from 'components/NavigationBar';
import {
    MAIN_TYPE_DISPATCH,
    MAIN_TYPE_MAINTENANCE,
    STATUS_CLOSED
} from 'constants/ticket';
import {
    updateDocumentTitle,
    fetchOperationUsers,
    fetchOneTicket,
    updateOneTicket,
    cleanOneTicket,
    toggleErrorDialog,
    toogleNavigation,
} from 'actions';
import TicketForm from './Form';
import addServiceZone from 'components/Map/Layers/service-zone';
import getAuthedToolBoxList from 'components/Map/util/get-authed-toolbox';
import {
    CENTER_TO_CURRENT_LOCATION,
    VMS,
} from 'components/Map/Toolbox';
import GoogleMap, { VIP_READ } from 'components/Map';
import './ticket-details.scss';


class TicketDetail extends Component {
    static propTypes = {
        opUsers: ImmutablePropTypes.list.isRequired,
        oneTicket: ImmutablePropTypes.map.isRequired,
    };

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            editMode: false,
            updating: false,
            newDueDate: undefined,
            doOnline: [],
            newDescription: undefined,
        };
        this.vipLayer = VIP_READ;
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(updateDocumentTitle('ticket.view_title'));
    }

    fetchData = () => {
        const { dispatch, match } = this.props;
        const { params } = match;

        return Promise.all([
            dispatch(fetchOneTicket(params.ticketId)),
            dispatch(fetchOperationUsers(params.ticketId))
        ]);
    }

    getDiff = newPayload => {
        const { oneTicket } = this.props;
        const jsonOneTicket = oneTicket.toJS();
        const keys = Object.keys(newPayload);

        const diff = keys.reduce((obj, key) => {
            if (newPayload[key] !== undefined && jsonOneTicket[key] !== newPayload[key]) {
                obj[key] = newPayload[key];
            }

            return obj;
        }, {});

        return [Object.keys(diff).length > 0, diff];
    }

    optionallyGetCustomFields = (custom_fields = {}) => {
        const { oneTicket } = this.props;
        const tracker_id = oneTicket.get('tracker_id');
        const origCustomFields = oneTicket.get('custom_fields');

        if (![MAIN_TYPE_DISPATCH, MAIN_TYPE_MAINTENANCE].includes(tracker_id)) {
            return undefined;
        }

        const availableIdList = origCustomFields
            .filter(({ editable }) => editable)
            .map(({ id }) => id.toString());

        return Object.values(custom_fields).reduce((ary, { id, value }) => {
            if (availableIdList.includes(id)) {
                ary.push({
                    id: Number(id),
                    value: value ?? '',
                });
            }

            return ary;
        }, []);
    }

    handleGoogleApi = ({ map, maps }) => {
        this.map = map;
        this.maps = maps;
        const { oneTicket } = this.props;
        const service_id = oneTicket.get('service_id');
        addServiceZone({
            map: this.map,
            params: { service_id },
            selected: true,
            vipLayer: this.vipLayer
        });
    }

    handleSubmit = e => {
        const { updating } = this.state;
        if (updating) {
            return;
        }

        const { oneTicket } = this.props;
        const id = oneTicket.get('id');
        const description_editable = oneTicket.get('description_editable');
        const { dispatch } = this.props;
        const payload = serialize(e.currentTarget, { hash: true });

        const {
            tracker_subtype_id,
            assigned_to_id,
            description = description_editable ? '' : undefined,
            due_date,
            severity_id,
            status_id,
            custom_fields,
            scooter_state_action
        } = payload;
        const [needUpdate, diff] = this.getDiff({
            assigned_to_id,
            description,
            due_date: convertToUTC(due_date) || undefined,
            tracker_subtype_id: Number(tracker_subtype_id) || undefined,
            severity_id: Number(severity_id) || undefined,
            status_id: Number(status_id) || undefined,
            custom_fields: this.optionallyGetCustomFields(custom_fields)
        });

        if (diff.status_id === STATUS_CLOSED && scooter_state_action) {
            diff.scooter_state_action = Number(scooter_state_action);
        }

        if (needUpdate) {
            this.setState({
                updating: true,
            });

            dispatch(updateOneTicket(id, diff)).then(({ error }) => {
                if (!error) {
                    this.toggleEditMode();
                    return;
                }
                else {
                    this.setState({
                        updating: false,
                    });
                }

                if (error.message === 'ticket.unclosed_tickets_error_message') {
                    dispatch(toggleErrorDialog(I18n.t(error.message)));
                }
                else if (error.response?.status === 409) {
                    dispatch(toggleErrorDialog(I18n.t('ticket.please_check_scooter_error_message')));
                }
                // without auth to access this ticket
                else if (error.response?.status === 403) {
                    dispatch(cleanOneTicket());
                    dispatch(toogleNavigation());
                }
                else {
                    if (error.response?.status !== 401) {
                        dispatch(toggleErrorDialog(I18n.t('ticket.general_error_message')));
                    }
                }


                this.toggleEditMode();
            });
        }
        else {
            this.toggleEditMode();
        }
    }

    toggleEditMode = () => {
        const { editMode } = this.state;
        this.setState({
            editMode: !editMode,
            updating: false,
            newDueDate: undefined,
            doOnline: [],
            newDescription: undefined,
        });
    }

    toggleUpdating = () => {
        const { updating } = this.state;
        this.setState({
            updating: !updating,
        });
    }

    handleChange = (name, value) => {
        const newState = {};

        switch (name) {
        case 'due_date':
            newState.newDueDate = value;
            break;
        case 'do_online':
            newState.doOnline = value;
            break;
        case 'description':
            newState.newDescription = value;
            break;
        default:
            // Do nothing
        }

        this.setState({
            ...newState,
        });
    }

    renderFunctionButton(status_id) {
        const { editMode, updating } = this.state;

        return (
            <AuthFeature requiredList={ [AUTH_EDIT_TICKET] }>
                <FlexGroup end gap>
                    { !editMode ? (
                        <Button
                            type="button"
                            color="primary"
                            onClick={ this.toggleEditMode }
                            disabled={ [STATUS_CLOSED, undefined].includes(status_id) }
                        >
                            <Translate value="ticket.edit_ticket_info" />
                        </Button>
                    ) : (
                        <React.Fragment>
                            <Button type="button" color="secondary" outline onClick={ this.toggleEditMode }>
                                <Translate value="cancel" />
                            </Button>
                            <Button type="submit" color="primary" disabled={ updating }>
                                <Translate value="save" />
                            </Button>
                        </React.Fragment>
                    ) }
                </FlexGroup>
            </AuthFeature>
        );
    }

    render() {
        const { match, oneTicket, opUsers } = this.props;
        const { params } = match;
        const { editMode, updating, newDueDate, doOnline, newDescription } = this.state;
        const jsonOneTicket = oneTicket.toJS();
        const {
            scooter_id,
            status_id,
            plate_no,
            tracker_id,
            tracker_subtype_id,
            due_date,
            description,
            service_type,
            scooter_model_code,
            location_lat,
            location_lng,
            __responseTime,
        } = jsonOneTicket;

        let current_location = null;
        let model_code = 0;

        current_location = {
            lat: location_lat,
            lng: location_lng
        };
        model_code = scooter_model_code;

        const ticketData = {
            ...jsonOneTicket,
            due_date: newDueDate ?? moment(due_date).format(I18n.t('datetime_format.long')),
            description: newDescription ?? description,
            doOnline,
            opUsers,
        };
        const pageTitle = (
            oneTicket.size > 0 ? [
                `#${ params.ticketId }: `,
                `[${ plate_no }]`,
                `[${ I18n.t(`ticket.main_type_${ tracker_id }`) }]`,
                `[${ I18n.t(`ticket.sub_type_${ tracker_subtype_id }`) }]`,
            ].join('') : null
        );
        const toolboxList = getAuthedToolBoxList([CENTER_TO_CURRENT_LOCATION, VMS]);

        return (
            <AuthView className="ticket-details">
                <Form
                    onSubmit={ this.handleSubmit }
                    inProgress={ updating }
                    inline
                >
                    <NavigationBar sticky title={ pageTitle }>
                        { this.renderFunctionButton(status_id) }
                    </NavigationBar>
                    <Smart
                        className="form-container"
                        fetch={ this.fetchData }
                        pauseRefresh
                        seamless
                    >
                        <FlexGroup className="refresh-section" end>
                            <Refresh onClick={ this.fetchData } time={ __responseTime } />
                        </FlexGroup>
                        <TicketForm
                            data={ ticketData }
                            editMode={ editMode }
                            updating={ updating }
                            onStartComment={ this.toggleUpdating }
                            onCompleteComment={ this.toggleUpdating }
                            onChange={ this.handleChange }
                        />
                        <GoogleMap
                            className="ticket-mission-map"
                            zoom={ 15 }
                            toolbox={ toolboxList }
                            onInternalAPI={ this.handleGoogleApi }
                            center={ current_location && {
                                lat: current_location.lat,
                                lng: current_location.lng,
                            } }
                            list={ scooter_id ? [{
                                id: scooter_id,
                                lat: current_location?.lat,
                                lng: current_location?.lng,
                                service_type,
                                model_code,
                                ...jsonOneTicket,
                            }] : [] }
                            currentLocation
                            withoutScooterCluster
                            vipLayer={ this.vipLayer }
                        />
                    </Smart>
                </Form>
            </AuthView>
        );
    }
}

export default connect(state => ({
    i18n: state.i18n,
    opUsers: state.account.get('opUsers'),
    oneTicket: state.ticket.get('oneTicket'),
}))(TicketDetail);
